<template>
  <a-modal
    :title="formTitle"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="公司ID" prop="companyId">
            <a-input
              v-model:value="form.companyId"
              placeholder="请输入公司ID"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="项目ID"
            prop="projectId"
          >
            <a-input
              v-model:value="form.projectId"
              placeholder="请输入项目ID"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="员工ID" prop="employeeId">
            <a-input
              v-model:value="form.employeeId"
              placeholder="请输入员工ID"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="员工名" prop="employeeName">
            <a-input v-model:value="form.employeeName" placeholder="请输入员工名" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item
            label="手环ID"
            prop="wristbandId"
          >
            <a-input
              v-model:value="form.wristbandId"
              placeholder="请输入手环ID"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="手环名称(岗位名)" prop="wristbandName">
            <a-input
              v-model:value="form.wristbandName"
              placeholder="请输入手环名称(岗位名)"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="统计开始时间" prop="startTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.startTime"
              format="YYYY-MM-DD HH:mm:ss"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="统计结束时间" prop="endTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.endTime"
              format="YYYY-MM-DD HH:mm:ss"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="步数" prop="stepCount">
            <a-input v-model:value="form.stepCount" placeholder="请输入步数" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="工作时长(分钟)" prop="totalDuration">
            <a-input
              v-model:value="form.totalDuration"
              placeholder="请输入工作时长(分钟)"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="任务总数" prop="taskNumber">
            <a-input v-model:value="form.taskNumber" placeholder="请输入任务总数" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="任务完成数" prop="completedNumber">
            <a-input
              v-model:value="form.completedNumber"
              placeholder="请输入任务完成数"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="投诉数" prop="complaintNumber">
            <a-input
              v-model:value="form.complaintNumber"
              placeholder="请输入投诉数"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="健康预警次数" prop="warningsNumber">
            <a-input
              v-model:value="form.warningsNumber"
              placeholder="请输入健康预警次数"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="状态" prop="status">
            <a-select
              v-model:value="form.status"
              placeholder="请选择状态"
              style="width: 100%"
              allow-clear
            >
              <a-select-option :value="1">显示</a-select-option>
              <a-select-option :value="0">不显示</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="排序" prop="sort">
            <a-input v-model:value="form.sort" placeholder="请输入排序" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-input
              v-model:value="form.remark"
              placeholder="请输入内容"
              type="textarea"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import {
  getUserOperations,
  addUserOperations,
  updateUserOperations,
} from '@/api/system/userOperations'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        companyId: null,

        projectId: null,

        employeeId: null,

        employeeName: null,

        wristbandId: null,

        wristbandName: null,

        startTime: null,

        endTime: null,

        stepCount: null,

        totalDuration: null,

        taskNumber: null,

        completedNumber: null,

        complaintNumber: null,

        warningsNumber: null,

        status: 0,

        sort: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
      },
    }
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        companyId: null,
        projectId: null,
        employeeId: null,
        employeeName: null,
        wristbandId: null,
        wristbandName: null,
        startTime: null,
        endTime: null,
        stepCount: null,
        totalDuration: null,
        taskNumber: null,
        completedNumber: null,
        complaintNumber: null,
        warningsNumber: null,
        status: 0,
        sort: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserOperations({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUserOperations(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addUserOperations(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px !important;
  padding-top: 24px !important;
  border-top: 1px solid #f0f0f0 !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form-model {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
